import styled from 'styled-components';

export const StyledProgressBarWrapper = styled.div`
  display: flex;
  margin: 0;
  align-items: center;
`;
